









































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import Modal from '@/components/common/Modal.vue'
import {Service} from '@/store/types'

@Component({
  components: {
    Modal,
  },
})
export default class ServiceEditItemModal extends Vue {
  @Getter('activeService') public activeService!: Service
  @Mutation('setServiceEditItemModal') public setServiceEditItemModal!: any
  @Action('editService') public editService!: any
  @Action('removeService') public removeService!: any

  public params: any = {
    distance: undefined,
    flights: undefined,
    num_of_hours: undefined,
    num_of_pallets: undefined,
    amount: undefined,
  }

  public get canBeUpdated() {
    return this.activeService.details.class_name === 'LongCarry' ||
      this.activeService.details.class_name === 'StairCarry' ||
      this.activeService.details.class_name === 'Palletizing' ||
      this.activeService.details.class_name === 'Waiting'
  }

  public edit() {
    const data: any = {}
    this.activeService.params = Object.assign({}, this.params)
    Object.assign(data, this.activeService)
    this.editService(data).then((response: Service) => {
      this.setServiceEditItemModal(false)
    })
  }
  public remove() {
    this.removeService(this.activeService).then((response: Service) => {
      this.setServiceEditItemModal(false)
    })
  }

  public serviceName(service: string) {
    return service.toLowerCase().split(' ').join('-')
  }

  public mounted() {
    Object.assign(this.params, this.activeService.params)
  }
}
